"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fetchCheckAndRefreshToken_1 = __importDefault(require("./helps/fetchCheckAndRefreshToken"));
const processRespons_1 = __importDefault(require("./helps/processRespons"));
const getManagement_1 = __importDefault(require("./service/getManagement"));
const interface_1 = require("./helps/interface");
const options = async () => {
    try {
        // console.log('%c start fnc options ', 'background: blue;color: white;');
        const refreshToken = localStorage.getItem('refreshToken');
        const path = window.location.pathname;
        if (path !== '/admin-options.html')
            return;
        if (!refreshToken)
            return window.location.href = '/admin-best.html';
        const formOptions = document.querySelector('form[name="options"]');
        const inputUsd = formOptions?.usd;
        const checkbox = formOptions?.ads;
        if (formOptions) {
            formOptions.addEventListener('submit', submitOptions);
        }
        //* получение данных для формы и установка значений 
        const management = await (0, getManagement_1.default)();
        console.log(management);
        if (management) {
            inputUsd.value = management.cursUsd;
            checkbox.checked = management.isShowBaner === 'true' ? true : false;
        }
        //* отправка данных с формы 
        async function submitOptions(event) {
            event.preventDefault();
            const curs = formOptions?.usd?.value.replace(',', '.');
            const isWorkAds = formOptions?.ads?.checked;
            if (curs && isWorkAds !== undefined) {
                const bodyOptions = {
                    isShowBaner: isWorkAds,
                    cursUsd: +curs
                };
                const url = interface_1.Link.Management;
                const options = {
                    method: 'POST',
                    headers: {
                        'Authorization': localStorage.getItem('accessToken') ?? '',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(bodyOptions),
                    "mode": "cors"
                };
                (0, fetchCheckAndRefreshToken_1.default)(url, options)
                    .then(res => res?.json())
                    .then((res) => (0, processRespons_1.default)(res))
                    .catch(error => console.log(error));
            }
        }
    }
    catch (error) {
        console.log('Error in Function options >>> ', error);
    }
};
exports.default = options;
